import Actions from '../actions'
import UserFacingAPIReturnTypes from '../../common/UserFacingAPIReturnTypes'

const defaultState = {
  isInit: false,
  serverTimeOffset: 0.0,
  constants: null,
  gameTypes: {},
  // systemMessage: {
  //   success: false,
  //   message: [],
  //   timestamp: 0,
  // },
  systemMessages: {}, // dictionary of messages, timestamp as UUID
}

function setServerTimeOffset (state, serverTimeOffset) {
  return { ...state,
    'serverTimeOffset': serverTimeOffset
  }
}

function setIsInit (state, isInit) {
  return { ...state,
    'isInit': isInit
  }
}

function setConstants (state, constants) {
  return { ...state,
    'constants': constants
  }
}

function setGameTypes (state, gameTypes) {
  return { ...state,
    'gameTypes': gameTypes
  }
}

// helper
function makeNewSystemMessage (message, type = UserFacingAPIReturnTypes['success']) {
  let timestamp = Date.now()
  return {
    type,
    message,
    timestamp
  }
}

function setSystemMessage (state, systemMessage) {
  systemMessage.timestamp = Date.now()
  let newSystemMessage = makeNewSystemMessage(systemMessage.message, systemMessage.type)
  return { ...state,
    'systemMessages': { ...state.systemMessages, 
      [newSystemMessage.timestamp]: newSystemMessage
    }
  }
}

function removeSystemMessage (state, messageId) {
  let newMesages = { ...state.systemMessages } // shallow copy
  delete newMesages[messageId] 
  return { ...state, 
    'systemMessages': newMesages
  }
}

function systemReducer (state = defaultState, action) {
  switch (action.type) {
    case Actions.SYSTEM_SET_SERVER_TIME_OFFSET:
      return setServerTimeOffset(state, action.payload)
    case Actions.SYSTEM_SET_IS_INIT:
      return setIsInit(state, action.payload)
    case Actions.SYSTEM_SET_CONSTANTS:
      return setConstants(state, action.payload)
    case Actions.SYSTEM_SET_GAME_TYPES:
      return setGameTypes(state, action.payload)
    case Actions.SYSTEM_SET_SYSTEM_MESSAGE:
      return setSystemMessage(state, action.payload)
    case Actions.SYSTEM_DELETE_SYSTEM_MESSAGE:
      return removeSystemMessage(state, action.payload)

    default:
      return state
  }
}

export default systemReducer
